import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react/dist/cjs/tabler-icons-react';
import classNames from 'classnames';
import { TeacherCardMatchingProgress } from '../../teacher-card-match-result/teacher-card-match-result';
import { matchedContentVariants, matchedItemVariants } from '../lib/teacher-matching-progress';
import s from '../teacher-matching-progress.module.scss';
import 'swiper/css';
import 'swiper/css/navigation';

export const MatchedTeachersSlider = ({ teachers }) => (
	<motion.div
		key="teachers"
		className={s.matchedSliderWrapper}
		variants={matchedContentVariants}
		initial="initial"
		animate="animate"
		exit="exit"
	>
		<button className={classNames(s.sliderButton, s.sliderPrev)} type="button" aria-label="Предыдущий преподаватель">
			<IconChevronLeft/>
		</button>
		<button className={classNames(s.sliderButton, s.sliderNext)} type="button" aria-label="Следующий преподаватель">
			<IconChevronRight/>
		</button>
		<Swiper
			className={s.matchedTeachers}
			modules={[Navigation]}
			slidesPerView="auto"
			spaceBetween={20}
			navigation={{
				prevEl: `.${s.sliderPrev}`,
				nextEl: `.${s.sliderNext}`,
			}}
			breakpoints={{
        768: {
          enabled: true
        },
      }}
		>
			{teachers?.map((teacher, index) => (
				<SwiperSlide className={s.matchedTeacherSlide} key={teacher?.teacher_slug || teacher?.id}>
					<motion.div variants={matchedItemVariants}>
						<TeacherCardMatchingProgress {...teacher} isRecomended={index === 0}/>
					</motion.div>
				</SwiperSlide>
			))}
		</Swiper>
	</motion.div>
);
